import { render } from "./member-interest-detail.vue?vue&type=template&id=67892f90&scoped=true"
import script from "./member-interest-detail.vue?vue&type=script&lang=js"
export * from "./member-interest-detail.vue?vue&type=script&lang=js"

import "./member-interest-detail.vue?vue&type=style&index=0&id=67892f90&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67892f90"]])